import request from '@/utils/request';
//活动分页数据
export function getQueryActivityPage(values) {
  return request('/activityStaff/queryActivityPage', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activityCoupon/delete', {
    method: 'POST',
    data: values,
  });
}
//审核活动
export function activityApprove(values) {
  return request('/activityStaff/approve', {
    method: 'POST',
    data: values,
  });
}
//取消活动
export function activityPause(values) {
  return request('/activityStaff/delete', {
    method: 'POST',
    data: values,
  });
}
